// JS calculo de cantidades en precios de la vsiat cart despues de hacer cambios en cantidad de producto

js_cart_total()
function js_cart_total(){
    document.addEventListener('DOMContentLoaded', initCartTotal)
}

function initCartTotal() {
    const buttons = document.querySelectorAll('.js-cart-total__button')
    const totals = document.querySelectorAll('.js-cart-total__total')
    const line_totals = document.querySelectorAll('.js-cart-total__line-total')
    const sends = document.querySelectorAll('.js-cart-total__send')
    
    // checkCart()

    if (buttons != null) {
        buttons.forEach(button => {
            button.addEventListener('click', ()=>{
                checkCart()
            })
        })
    }

    function checkCart() {
        const cart = JSON.parse(localStorage.atom_cart)
        printPrices(cart)
    }

    function printPrices(cart) {
        const formatter = new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2
        })
        
        if (totals != null) {
            totals.forEach(total => {
                total.innerHTML = 'MXN $ ' + formatter.format(cart.total_price/100)
            })
        }

        if (line_totals != null) {
            line_totals.forEach(total => {
                cart.items.forEach(item => {
                    if (total.dataset.id == item.id) {
                        total.innerHTML = 'MXN $ ' + formatter.format(item.final_line_price/100)
                    }
                })
                
            })
        }

        if (sends != null) {
            sends.forEach(send => {
                if ((send.dataset.send/1) > (cart.total_price/100) ) {
                    const envio = (send.dataset.send/1) - (cart.total_price/100)
                    send.innerHTML = `TE FALTAN $ ${formatter.format(envio)} PARA ENVÍO GRATIS`
                }else{
                    send.innerHTML = `YA TIENES ENVÍO GRATIS`
                }
            })
        }
    }
}
